import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class CreateStructuredStorageHelper extends StructuredStorageBaseHelper {
    constructor({ prefix, ...rest }) {
        super(rest);
        this.prefix = prefix;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitPushInt(node, 0);
        sb.emitPushString(node, this.prefix);
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'PACK');
        sb.emitOp(node, 'NEWSTRUCT');
        sb.emitHelper(node, options, sb.helpers.wrapVal({ type: this.type }));
    }
}

//# sourceMappingURL=CreateStructuredStorageHelper.js.map
